import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const Title = styled.h2`
  font-size: 3rem;
  text-align: center;
  color: #18216d;
  margin-bottom: 60px;
  font-weight: 700;
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-bottom: 0px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceCard = styled.div`
  background-color: #f9fafb;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
  transition: transform 0.3s ease, border-color 0.3s ease;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-6px);
    border-color: #3182ce;
  }

  &:hover h3 {
    color: #ff6600; /* your orange */
  }

  h3 {
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    color: #000000; /* black */
    font-weight: 400; /* normal */
    margin-bottom: 12px;

    svg {
      margin-right: 10px;
      color: #3182ce;
      font-size: 1.4rem;
      flex-shrink: 0;
    }
  }

  ul {
    padding-left: 20px;
    color: #4a5568;
    font-size: 0.95rem;
    line-height: 1.5;

    margin: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;

    li {
      margin-bottom: 8px;
    }
  }

  &:hover ul {
    max-height: 500px;
  }
`;
